export default "__VITE_ASSET__2NJUZwfZkcRHrj2qUeXAMQ__"